/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BookedExamResponse
 */
export interface BookedExamResponse {
    /**
     * 
     * @type {number}
     * @memberof BookedExamResponse
     */
    examId?: number;
    /**
     * 
     * @type {number}
     * @memberof BookedExamResponse
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BookedExamResponse
     */
    gweGateExam?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BookedExamResponse
     */
    examShortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookedExamResponse
     */
    examName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BookedExamResponse
     */
    cancelDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BookedExamResponse
     */
    cancellableUntil?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof BookedExamResponse
     */
    accountedRef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookedExamResponse
     */
    choiceOfRein?: string | null;
}

/**
 * Check if a given object implements the BookedExamResponse interface.
 */
export function instanceOfBookedExamResponse(value: object): value is BookedExamResponse {
    return true;
}

export function BookedExamResponseFromJSON(json: any): BookedExamResponse {
    return BookedExamResponseFromJSONTyped(json, false);
}

export function BookedExamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookedExamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'examId': json['examId'] == null ? undefined : json['examId'],
        'price': json['price'] == null ? undefined : json['price'],
        'gweGateExam': json['gweGateExam'] == null ? undefined : json['gweGateExam'],
        'examShortName': json['examShortName'] == null ? undefined : json['examShortName'],
        'examName': json['examName'] == null ? undefined : json['examName'],
        'cancelDate': json['cancelDate'] == null ? undefined : (new Date(json['cancelDate'])),
        'cancellableUntil': json['cancellableUntil'] == null ? undefined : (new Date(json['cancellableUntil'])),
        'accountedRef': json['accountedRef'] == null ? undefined : json['accountedRef'],
        'choiceOfRein': json['choiceOfRein'] == null ? undefined : json['choiceOfRein'],
    };
}

export function BookedExamResponseToJSON(json: any): BookedExamResponse {
    return BookedExamResponseToJSONTyped(json, false);
}

export function BookedExamResponseToJSONTyped(value?: BookedExamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'examId': value['examId'],
        'price': value['price'],
        'gweGateExam': value['gweGateExam'],
        'examShortName': value['examShortName'],
        'examName': value['examName'],
        'cancelDate': value['cancelDate'] == null ? undefined : ((value['cancelDate'] as any).toISOString()),
        'cancellableUntil': value['cancellableUntil'] == null ? undefined : ((value['cancellableUntil'] as any).toISOString()),
        'accountedRef': value['accountedRef'],
        'choiceOfRein': value['choiceOfRein'],
    };
}

